import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components'
import toast from 'react-hot-toast';
import Api from '../../utils/Api';

const styles = css`
display: flex;
flex-wrap: wrap;
flex-direction: column;
width: 100%;
max-width: 400px;
margin: auto;
align-content: center;
text-align: center;
gap: 20px;
margin-top: 5vh;
.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
`
const GroupsNew = styled(({ className }) => {
  const navigate = useNavigate();
  const [newGroupName, setNewGroupName] = useState('');
  const isSubmitOk = newGroupName !== '';

  const cancel = () => {
    navigate(-1);
  }

  const save = async () => {
    if (isSubmitOk) {
      const [error, group] = await Api.createGroup({
        name: newGroupName,
      });
      if (error) {
        toast.error(Api.error(error));
        console.error(error);
      } else {
        toast.success('Group added successfully');
        navigate(`/groups/details/${group._id}`);
      }
    }
  }

  return (
    <div className={className}>
      <div>
        Create New Group
      </div>
      <div>
        <input placeholder='New group name' value={newGroupName} onChange={e => setNewGroupName(e.target.value)} />
      </div>
      <div className='buttons'>
        <button className='danger' onClick={cancel}>Cancel</button>
        <button disabled={!isSubmitOk} className='primary' onClick={save}>Save</button>
      </div>
    </div>
  )
})`${styles}`;

export default GroupsNew
